import { render } from "./TopicsByFolder.vue?vue&type=template&id=988d10cc&scoped=true"
import script from "./TopicsByFolder.vue?vue&type=script&lang=js"
export * from "./TopicsByFolder.vue?vue&type=script&lang=js"

import "./TopicsByFolder.vue?vue&type=style&index=0&id=988d10cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988d10cc"]])

export default __exports__